import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-Ú",
  "use": "icon-Ú-usage",
  "viewBox": "0 0 61 60",
  "content": "<symbol viewBox=\"0 0 61 60\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-Ú\">\n<path d=\"M49.8139 28.072H11.5579C10.5979 28.072 9.82993 28.84 9.82993 29.8C9.82993 30.76 10.5979 31.528 11.5579 31.528H49.8139C50.7739 31.528 51.5419 30.76 51.5419 29.8C51.5419 28.84 50.7739 28.072 49.8139 28.072Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol